import { lang } from '../../assets/lang'

const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

const typesFb = [
  { key: 'new_post_back', value: lang.button_html_types_postback_new },
  { key: 'post_back', value: lang.button_html_types_postback },
  { key: 'web_url', value: lang.button_html_types_web_url },
  { key: 'web_url_full', value: lang.button_html_types_web_url_full },
  { key: 'web_url_compact', value: lang.button_html_types_web_url_compact },
  { key: 'web_url_tall', value: lang.button_html_types_web_url_tall },
  { key: 'web_url_birthday', value: lang.button_html_types_web_url_birthday },
  { key: 'web_url_email', value: lang.button_html_types_web_url_email },
  { key: 'web_url_phone', value: lang.button_html_types_web_url_phone },
  { key: 'web_url_location', value: lang.button_html_types_web_url_location },
  { key: 'phone_number', value: lang.button_html_types_phone_number },
  { key: 'UNSUBSCRIBE_QUICK_BOXER', value: lang.button_html_types_unsubscribe },
  { key: 'RESUBSCRIBE_QUICK_BOXER', value: lang.button_html_types_resubscribe },
  { key: 'YES_START_CHAT_WITH_HUMAN', value: lang.button_html_types_with_human },
  { key: 'YES_START_CHAT_WITH_BOT', value: lang.button_html_types_with_robot },
]

const typesIg = [
  { key: 'new_post_back', value: lang.button_html_types_postback_new },
  { key: 'post_back', value: lang.button_html_types_postback },
  { key: 'web_url', value: lang.button_html_types_web_url },
  { key: 'web_url_birthday', value: lang.button_html_types_web_url_birthday },
  { key: 'web_url_email', value: lang.button_html_types_web_url_email },
  { key: 'web_url_phone', value: lang.button_html_types_web_url_phone },
  { key: 'web_url_location', value: lang.button_html_types_web_url_location },
]

export const types = instagram_bot_addon ? typesIg : typesFb

